export default __webpack_public_path__ + "img/1.07716ddf.jpg";